<template>
  <div class="home">
  <br>
  <textarea placeholder="ent3r text t0 transl@t3" v-model="text" rows="10"></textarea>
  <p id="output">{{ out }}</p>
  <button class="copy" @click="copytext">copy</button>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  mounted() {
	for (var key in this.translate){
		this.inverted[this.translate[key]] = key;
	}
  },
  data() {
	return {
		lower: true,
		text: '',
		translate: {
			'A': '|',
			'B': '┤',
			'C': '╭',
			'D': '┘',
			'E': '3',
			'F': '╕',
			'G': '╗',
			'H': '╫',
			'I': '┇',
			'J': '╛',
			'K': '╮',
			'L': '╪',
			'M': '┬',
			'N': '╖',
			'O': '┼',
			'P': '╝',
			'Q': '╜',
			'R': '╡',
			'S': '┅',
			'T': '╤',
			'U': '╧',
			'V': '┴',
			'W': '╩',
			'X': '╬',
			'Y': '╣',
			'Z': '╨',
			'1': '⏈',
			'2': '⏆',
			'3': '⏇',
			'4': '⏂',
			'5': '⊕',
			'6': '⏁',
			'7': '⏅',
			'8': '⏃',
			'9': '⏄',
			'0': '⍏',
			' ': '_ '
		},
		inverted: {},
	}
  },
  computed: {
	out() {
		return this.output();
	},
  },
  methods: {
	output() {
		let out = ''
		let text = this.text.toUpperCase()
		for(var i = 0; i < text.length; i++){
			if (i < text.length - 1 && text.charAt(i) == '_' && text.charAt(i + 1) == ' '){
				out += ' '
				i++
			}
			else if (text.charAt(i) in this.inverted){
				out += this.inverted[text.charAt(i)]
			}
			else if(!(text.charAt(i) in this.translate)){
				out += text.charAt(i)
			}
			else{
				out += this.translate[text.charAt(i)]
			}
		}
		return out;
	},
	copytext(){
		let text = this.output()
		navigator.clipboard.writeText(text);
	},
  }

}
</script>
